import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from './form/Checkbox';
import formatOERLabel from '../util/formatOERLabel';

export default class OerCheckbox extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired
  }
  handleChange = oer => (event, value) => {
    this.props.handleChange(oer, event, value);
  }

  render() {
    const {oer} = this.props;
    return (
      <div className="admin__checkbox">
        <Checkbox
          checked={this.props.checked}
          onChange={this.handleChange(oer)}
          label={formatOERLabel(oer.id)}
        />
      </div>
    );
  }
}
